module.exports = __webpack_public_path__ + "static/media/services5.e2aa8a04.png";